import styled from "styled-components"

interface Props {
  children: React.ReactNode
  currentStep?: number
}

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  padding: 0 20px 0 20px;

  @media (max-width: 1023px) {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    align-items: center;
    width: 100vw;
    // height: 80vh;
  }
`

const SummaryContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  align-items: center;
  padding: 0 20px 0 20px;
`

const FlexContainer = styled.div`
  display: flex;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: stretch;
    padding: 0 10px;
    max-width: 100vw;
  }
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 500px) {
    max-width: 100vw;
  }
`

export default function Content({ children, currentStep }: Props) {
  if (currentStep === 3) {
    return <SummaryContainer>{children}</SummaryContainer>
  } else if (currentStep === 0 || currentStep === 1 || currentStep === 2) {
    return <GridContainer>{children}</GridContainer>
  } else if (currentStep === 0) {
    return <FlexContainer>{children}</FlexContainer>
  } else {
    return <ContentContainer>{children}</ContentContainer>
  }
}
